<template>
  <section class="dd-crypto-page">
    <div class="dd-crypto-page__inner">
      <SubscriptionCryptoPaymentPanel />
    </div>
  </section>
</template>

<script>
import SubscriptionCryptoPaymentPanel from '@/new/components/wall/SubscriptionCryptoPaymentPanel.vue';
import {logWarn} from '@/helpers';

export default {
  name: 'WallSubscriptionCryptoPayment',
  components: { SubscriptionCryptoPaymentPanel },
  computed: {
    hasCryptoPaymentInProgress() {
      return !!this.$store.getters.cryptocurrencyPaymentMode;
    },
    hasPendingUpgrade() {
      return !!this.$store.state.pendingUpgradeInfo;
    },
  },
  created() {
    this.ensurePaymentContext();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.ensurePaymentContext());
  },
  beforeRouteUpdate(to, from, next) {
    this.ensurePaymentContext(next);
  },
  methods: {
    ensurePaymentContext(next) {
      const hasInitialPending = !!(window.appConfig && (window.appConfig.pending_crypto_payment || window.appConfig.pending_info));
      if (!this.hasCryptoPaymentInProgress && !this.hasPendingUpgrade && !hasInitialPending) {
        if (next) next(false);
        // Defer navigation to avoid cancel loops
        this.$nextTick(() => {
          this.$router.replace('/wall/subscription').catch((err) => {
            if (!err || err.name !== 'NavigationDuplicated') {
              logWarn('Failed to navigate back from subscription crypto view', err);
            }
          });
        });
        return;
      }
      if (next) next();
    },
  },
};
</script>

<style scoped>
.dd-crypto-page {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}
.dd-crypto-page__inner {
  width: 100%;
  max-width: 760px;
}
@media (max-width: 480px) {
  .dd-crypto-page {
    margin-top: 0;
  }
}
</style>
